import { ObtieneComuna, ObtieneGenero, ObtienePaisNacionalidad,ObtieneComunaHomologa } from "../../../application/interactors/Combos";

export const ObtieneComunaLogic = (selListaComunas: any, codigoNegocio: number) => {
    return ObtieneComuna(selListaComunas, codigoNegocio);
}

export const ObtieneGeneroLogic = (selListaGenero: any) => {
    return ObtieneGenero(selListaGenero);
}

export const ObtienePaisNacionalidadLogic = (selListaPaisNacionalidad: any, codigoNegocio: number) => {
    return ObtienePaisNacionalidad(selListaPaisNacionalidad, codigoNegocio);
}
export const ObtieneComunaHomologaLogic = (    
    SelObtieneComunaHomologa:any,
    CodComuna: number,
    Comuna_Db_Finanzas:string,
    Cod_Comuna_Db_Docencia:number 
) => {
    return ObtieneComunaHomologa(
        SelObtieneComunaHomologa,
        CodComuna,
        Comuna_Db_Finanzas,
        Cod_Comuna_Db_Docencia 
    );
}